import { render, staticRenderFns } from "./SpinnerAudioLoader.vue?vue&type=template&id=5f3cd1ae&functional=true&"
import script from "./SpinnerAudioLoader.vue?vue&type=script&lang=js&"
export * from "./SpinnerAudioLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports